<template>
  <div v-if="report.companyoverview.creditreport">
    <report-panel :report="report" :anchor="''">
      <div slot="title">Credit Limits</div>
      <div slot="body">
        <table class="table table-striped" id="credit-limits-table">
          <th>Start Date</th>
          <th style="text-align: right">Potential Limit</th>
          <tbody>
            <tr
              v-for="limit in report.companyoverview.creditreport.creditlimits.slice(0, 5)"
              :key="limit.id"
            >
              <td>{{ isEmptyMessage(formatDate(limit.start_date)) }}</td>
              <td style="text-align: right" v-html="creditLimit(limit)">
                <!-- {{ isEmptyMessage(formatCurrency(limit.value, limit.currency.html_symbol )) }} -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  methods: {
    creditLimit(limit) {
      let symbol = '';
      if(this.report.companyoverview.currency !== null) {
        symbol = this.report.companyoverview.currency.html_symbol;
      } else {
        if(limit.currency !== null) {
          symbol = limit.currency.html_symbol;
        }
      }
      return this.isEmptyMessage(this.formatCurrency(limit.value, symbol))
    }
  },
  mixins: [toolsMixin],
  props: ['report'],
};
</script>
